/* Warehouse Gear Hub — mega menu header.
   Hover intent (80ms open / 160ms close) for mouse users, open-on-click for
   touch and keyboard, Escape and outside-click to close, real focus
   management so the panel is reachable and dismissible without a mouse.
   Also publishes --sticky-header-offset (the header's height) so sticky
   sidebars and buy panels sit below it. Re-initialises on section reload in
   the theme editor. */
(function () {
  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 160;

  function init(root) {
    if (!root || root.__wghInit) return;
    root.__wghInit = true;

    const hover = root.getAttribute('data-hover') === 'true';
    // Triggers may be <a> (parent has a real URL) or <button> ('#' parents).
    // A link navigates on a mouse click because hover already opened its
    // panel; on touch, the first tap opens the panel and the second follows
    // the link. Keyboard: Enter follows the link, ArrowDown opens the panel.
    const canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
    const triggers = Array.from(root.querySelectorAll('[data-wgh-mm-trigger]'));
    const panels = Array.from(root.querySelectorAll('[data-wgh-mm-panel]'));
    let openId = null;
    let timer = null;

    const panelFor = (id) => panels.find((p) => p.id === id);
    const triggerFor = (id) => triggers.find((t) => t.getAttribute('aria-controls') === id);

    const setOpen = (id) => {
      if (openId === id) return;
      if (openId) {
        const p = panelFor(openId); const t = triggerFor(openId);
        if (p) p.hidden = true;
        if (t) t.setAttribute('aria-expanded', 'false');
      }
      openId = id;
      if (id) {
        const p = panelFor(id); const t = triggerFor(id);
        if (p) p.hidden = false;
        if (t) t.setAttribute('aria-expanded', 'true');
      }
    };
    const schedule = (id, ms) => { clearTimeout(timer); timer = setTimeout(() => setOpen(id), ms); };
    const close = () => { clearTimeout(timer); setOpen(null); };

    triggers.forEach((t) => {
      const id = t.getAttribute('aria-controls');
      const isLink = t.tagName === 'A' && t.getAttribute('href');
      t.addEventListener('click', (e) => {
        if (isLink) {
          if (hover && canHover) return; // mouse: follow the link
          if (openId !== id) { e.preventDefault(); clearTimeout(timer); setOpen(id); } // touch: first tap opens
          return; // second tap follows the link
        }
        clearTimeout(timer); setOpen(openId === id ? null : id);
      });
      if (hover) {
        t.addEventListener('mouseenter', () => schedule(id, OPEN_DELAY));
      }
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown' || (!isLink && e.key === 'Enter' && openId !== id)) {
          e.preventDefault();
          clearTimeout(timer);
          setOpen(id);
          const first = panelFor(id) && panelFor(id).querySelector('a, button');
          if (first) first.focus();
        }
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          const i = triggers.indexOf(t);
          const next = triggers[(i + (e.key === 'ArrowRight' ? 1 : -1) + triggers.length) % triggers.length];
          if (next) { e.preventDefault(); next.focus(); }
        }
      });
    });
    panels.forEach((p) => {
      if (hover) {
        p.addEventListener('mouseenter', () => clearTimeout(timer));
      }
      p.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') { e.preventDefault(); const t = triggerFor(p.id); close(); if (t) t.focus(); }
      });
    });
    if (hover) {
      root.addEventListener('mouseleave', () => schedule(null, CLOSE_DELAY));
    }
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && openId) { const t = triggerFor(openId); close(); if (t) t.focus(); } });
    document.addEventListener('mousedown', (e) => { if (openId && !root.contains(e.target)) close(); });
    root.addEventListener('focusout', (e) => {
      if (!openId) return;
      const to = e.relatedTarget;
      if (to && !root.contains(to)) close();
    });
  }

  function initDrawer(header) {
    const drawer = header.querySelector('[data-wgh-mnav]');
    const burger = header.querySelector('[data-wgh-mnav-open]');
    if (!drawer || !burger || drawer.__wghInit) return;
    drawer.__wghInit = true;
    const open = (on) => {
      drawer.classList.toggle('is-open', on);
      burger.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.body.classList.toggle('wgh-mnav-open', on);
      if (on) { const c = drawer.querySelector('[data-wgh-mnav-close]'); c && c.focus(); } else burger.focus();
    };
    burger.addEventListener('click', () => open(!drawer.classList.contains('is-open')));
    drawer.addEventListener('click', (e) => {
      if (e.target.closest('[data-wgh-mnav-close]') || e.target.classList.contains('wgh-mnav__backdrop')) open(false);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) open(false); });
  }

  function publishOffset(header) {
    const section = header.closest('.wgh-header-section');
    const sticky = section && section.classList.contains('wgh-header-section--sticky');
    const set = () => {
      document.body.style.setProperty('--sticky-header-offset', sticky ? `${header.offsetHeight}px` : '0px');
    };
    set();
    if ('ResizeObserver' in window) new ResizeObserver(set).observe(header);
    else window.addEventListener('resize', set);
  }

  function boot() {
    document.querySelectorAll('[data-wgh-header]').forEach((header) => {
      const mm = header.querySelector('[data-wgh-mm]');
      if (mm) init(mm);
      initDrawer(header);
      publishOffset(header);
    });
  }
  boot();
  document.addEventListener('shopify:section:load', boot);
})();
